module.exports = {
  ACTIVE: 1,
  INACTIVE_PAYMENT: 2, // inativo por falta de pagamento
  INACTIVE_ADMIN: 3, // inativo por cancelamento do admin
};